import React, { useContext } from 'react';
import {
    Row, Col, Typography, Button,
    Table, Divider, Popconfirm
} from 'antd';
import Icon, { DeleteOutlined } from '@ant-design/icons';
import { FaRegFilePdf } from 'react-icons/fa';
import locale from 'antd/es/locale/pt_BR';

import { GlobalContext } from '../../../../contexts/globalContext';
import LayoutDashboard from './../../../../layout/LayoutAdmin';

import './style.css';
import { useCertidoes } from './useCertidoes';

const { Text, Title } = Typography;

const IconFilePDF = (props: any) => (<Icon {...props} component={FaRegFilePdf} ></Icon>);

const CertidoesCongelamento: React.FC = () => {

    const { theme } = useContext(GlobalContext);

    const {
        refContagemDoFiltro,
        columns,
        dadosTabelaState,
        navigate,
        clickBotaoEditar,
        hasSelectedEdit,
        clickBotaoDeletarDados,
        loadingScreen,
        onclickTable,
        rowSelection,
    } = useCertidoes();

    return (
        <LayoutDashboard>
            <Row>
                <Col span={24}>
                    <Title level={4}>
                        <IconFilePDF style={{ fontSize: 23, marginRight: 10 }} />
                        {"Certidões"}
                    </Title>
                    <Divider />
                </Col>
            </Row>
            <div
                style={{
                    display: 'flex',
                }}
            >
                <Button
                    type="primary"
                    className="CongelamentoCertidoes_BotaoVerde_edfrgjkfbrefg"
                    style={{ margin: 2 }}
                    disabled={!(rowSelection.selectedRowKeys.length === 0)}
                    onClick={() => {
                        let dadosLocalStorage: string | null = localStorage.getItem('@DesenvolveSP:configuracoesEditar');
                        let localUserData: any = null;
                        if (typeof dadosLocalStorage == 'string') {
                            localUserData = JSON.parse(dadosLocalStorage);
                        }

                        if (localUserData) {
                            localStorage.removeItem('@DesenvolveSP:configuracoesEditar');
                        }

                        navigate('/congelamento-cnpj/certidoes/criar')
                    }}
                >
                    Adicionar
                </Button>
                <Button
                    type="default"
                    style={{ margin: 2 }}
                    className="CongelamentoCertidoes_BotaoAmarelo_dslkcjbsdcpi"
                    onClick={clickBotaoEditar}
                    disabled={!hasSelectedEdit}
                >
                    Editar
                </Button>
                <Popconfirm
                    title="Deseja excluir?"
                    onConfirm={clickBotaoDeletarDados}
                    onCancel={() => { }}
                    okText="Sim"
                    cancelText="Não"
                >
                    <Button className="botaoDeleteAssociacao"
                        type="primary"
                        danger

                        style={{ margin: 2 }}
                        // disabled={!hasSelectedDel}
                        disabled={!hasSelectedEdit}
                    >
                        <DeleteOutlined />
                    </Button>
                </Popconfirm>
            </div>

            <Table
                style={{
                    // marginTop: 50
                }}
                className='marginTopTables'
                rowKey={(record) => record.id}
                loading={loadingScreen}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { onclickTable(record, rowIndex) }, // click row
                        onDoubleClick: event => { }, // double click row
                        onContextMenu: event => { }, // right button click row
                        onMouseEnter: event => { }, // mouse enter row
                        onMouseLeave: event => { }, // mouse leave row
                    };
                }}
                rowSelection={rowSelection}
                columns={columns} dataSource={dadosTabelaState}
                scroll={{ x: 850 }}
                onChange={
                    (pagination, filters, sorter, extra) => {
                        refContagemDoFiltro.current = extra.currentDataSource
                    }
                }
                title={(registros) => {

                    return (
                        <div
                            style={{
                                backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                padding: 10,
                                margin: -8,
                                marginBottom: 0.5
                            }}
                        >
                            <Text>
                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    )
                }}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: 'end'
                            }}
                        >
                            <Text>
                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    )
                }}
                size="small"
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    position: ['topRight', 'bottomRight'],
                    pageSizeOptions: ['10', '20', '50', '100']
                }}
                locale={locale.Table}
            />

        </LayoutDashboard >
    );
}

export default CertidoesCongelamento;
